export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MS_CLIENT_ID,
    authority: process.env.REACT_APP_MS_AUTHORITY,
    redirectUri: process.env.REACT_APP_MS_REDIRECTURI,
    postLogoutRedirectUri: process.env.REACT_APP_MS_LOGOUT_REDIRECTURI,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: [process.env.REACT_APP_MS_SCOPES],
  prompt: "select_account",
  redirectStartPage: process.env.REACT_APP_MS_REDIRECTURI,
};
